export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Після завершення угоди вона буде закрита. Внутрішні кошти будуть переведені користувачу."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ви впевнені, що хочете завершити угоду?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Так, завершити"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ні, залишити активною"])}
}